import React from "react"
import PropTypes from "prop-types"
import CopyToClipboard from "react-copy-to-clipboard"

import {FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import StockType from "@irati/stock/enums/StockType"
import {Label} from "@irati/ui/src/Typography"

function getText(voucher) {
  const url = voucher.type === StockType.URL
  const pdf = voucher.type === StockType.PDF
  if (url || pdf) {
    return <FormattedMessage id="perks.components.tickets.ticket.copyButton.link" />
  }

  return <FormattedMessage id="perks.components.tickets.ticket.copyButton.code" />
}

const DealSuccessTicketActionButton = ({voucher, onCopy, asLabel}) => {
  if (!voucher.code) {
    return null
  }

  const text = getText(voucher)

  return (
    <CopyToClipboard text={voucher.code} onCopy={onCopy}>
      <span>
        {!asLabel && (
          <Button primary full>
            {text}
          </Button>
        )}

        {asLabel && <Label>{text}</Label>}
      </span>
    </CopyToClipboard>
  )
}

DealSuccessTicketActionButton.propTypes = {
  voucher: PropTypes.shape({
    code: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  onCopy: PropTypes.func.isRequired,
  asLabel: PropTypes.bool
}

DealSuccessTicketActionButton.defaultProps = {
  asLabel: false
}

export default DealSuccessTicketActionButton
